<template>
<div>
  <div class="container">
    <div class="row">
      <div style="width: 100%;">
        <h4 class="search-user game-search-boder">
          <div style="font-size: 14px; color: gray;" @click="openModal()">
            <div class="search-game-form"> 
              <i class="fas fa-search"></i>
              レベル・ランク・プレイスタイル
            </div>
          </div>
        </h4>
      </div>
    </div>
  </div>
  <gameSearchModal
    :showModal="this.showModal"
    :gameDatas="this.selectedGamedatas"
    :game="this.game"
    @close-modal="closeModal"
  />
</div>
</template>

<script>
  import axios from 'packs/axios'
  import gameSearchModal from 'packs/components/search/game-search-modal'

  export default {
    data: function () {
      return {
        currentUser: "",
        showModal: false,
        selectedGamedatas:[],
        game:[]
      }
    },
    computed: {
    },
    components: {
      gameSearchModal
    },
    methods: {
      fetchCurrentUser: function(){
      var self = this;
      axios.get("/api/v1/current_user")
      .then(function(res) {
        self.isLoading = false;
        self.currentUser = res.data.currentUser;
      }).catch((err) => {   
          this.isLoading = false;                 
      })
      },
      openModal: function(){
        this.showModal = true
      },
      closeModal: function(e){
        this.showModal = false
      },
    },
    created () {
      this.fetchCurrentUser()
      const element = document.getElementById("game-search");
      const data = JSON.parse(element.getAttribute('data'));
      var self = this;
      this.game = data.game
      const select_game = {
          game_id: data.game.id,
      }
      axios.get(`/api/v1/game_skills`, { params: select_game})
      .then(function(res) {
        self.selectedGamedatas = res.data.game_skill
      }).catch((err) => {   
        this.isLoading = false;                 
      })
    },
  }
</script>

<style scoped>
  .color-red{
    color:red !important;
  }
  .color-green{
    color:green;
  }
  .search-form{
    font-size: 16px;
    font-weight: 600;
    padding: 4px 0;
    margin-bottom: 8px;
    align-items: center;
    text-align: center;
  }
</style>
